import coverZad from "@images/clients/covers/cover-zad.webp";
import coverOkeeffes from "@images/clients/covers/cover-okeeffes.webp";
import coverFamous from "@images/clients/covers/cover-famous.webp";
import coverEiffel from "@images/clients/covers/cover-eiffel.webp";
import coverKayla from "@images/clients/covers/cover-kayla.webp";
import coverDar from "@images/clients/covers/cover-dar.webp";

// Client logo on a solid brand-colour background (FAMOUS style). Shared by
// the social-media page and the portfolio cards; matched on the real
// project name, so new clients just need a cover + one entry here.
export const CLIENT_COVERS = [
    { match: "زاد السعدين", name: "مطبخ زاد السعدين", cover: coverZad },
    { match: "Keeffe", name: "O’Keeffe’s", cover: coverOkeeffes },
    { match: "FAMOUS", name: "FAMOUS", cover: coverFamous },
    { match: "ايفل", name: "Eiffel Perfume", cover: coverEiffel },
    { match: "kaylahairsa", name: "Kayla", cover: coverKayla },
    { match: "دار العلاج", name: "عيادات دار العلاج", cover: coverDar },
];

export const clientCoverFor = (name = "") => CLIENT_COVERS.find((c) => name.includes(c.match)) || null;
